import { isEqual } from 'lodash-es';
import { type Dispatch, type SetStateAction, useEffect, useState } from 'react';
import { type ActiveReviewParams } from '../types.ts';
import { useActiveReviewDrawerParams } from './useActiveReviewDrawerParams.ts';

export const useActiveReviewDrawer = (): [
  ActiveReviewParams | undefined,
  Dispatch<SetStateAction<ActiveReviewParams | undefined>>,
] => {
  const [activeReviewDrawerParams, setActiveReviewDrawerParams] = useActiveReviewDrawerParams();

  const [activeReviewDrawer, setActiveReviewDrawer] = useState<ActiveReviewParams | undefined>(
    activeReviewDrawerParams,
  );

  useEffect(() => {
    if (!isEqual(activeReviewDrawerParams, activeReviewDrawer)) {
      setActiveReviewDrawerParams(activeReviewDrawer);
    }
    // We only want to re-execute when id changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeReviewDrawer?.id]);

  useEffect(() => {
    if (!isEqual(activeReviewDrawerParams, activeReviewDrawer)) {
      setActiveReviewDrawer(activeReviewDrawerParams);
    }
    // We only want to re-execute when id changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeReviewDrawerParams?.id]);

  return [activeReviewDrawer, setActiveReviewDrawer];
};
